// @flow
import * as React from 'react';

import {Table, TableHeaderCell, TableCell, Heading} from 'docs/components';
import type {
  ReportsContext,
  ReportsContextBalanceTransactionType as BalanceTransaction,
  ReportsContextBalanceTransactionGroup as BalanceTransactionGroup,
} from 'docs/types';

type BalanceTransactionsMap = $PropertyType<
  ReportsContext,
  'balance_transactions_map',
>;

type BalanceTransactionGroupList = $PropertyType<
  ReportsContext,
  'balance_transaction_groups',
>;

type BalanceTransactionTableProps = {|
  balanceTransactionGroups: BalanceTransactionGroupList,
  balanceTransactionsMap: BalanceTransactionsMap,
|};

type BalanceTransactionGroupSectionProps = {|
  balanceTransactionGroup: BalanceTransactionGroup,
  balanceTransactionTypes: Array<BalanceTransaction>,
|};

type BalanceTransactionGroupTableProps = {|
  balanceTransactionTypes: Array<BalanceTransaction>,
|};

const BalanceTransactionGroupTable = ({
  balanceTransactionTypes,
}: BalanceTransactionGroupTableProps) => {
  const rows = balanceTransactionTypes.map((type) => {
    return (
      <tr key={type.id}>
        <TableCell align="right">
          <strong>{type.id}</strong>
        </TableCell>
        <TableCell>{type.description}</TableCell>
      </tr>
    );
  });
  return (
    <Table type="solid">
      <thead>
        <tr>
          <TableHeaderCell align="right">
            <strong>Type</strong>
          </TableHeaderCell>
          <TableHeaderCell>
            <strong>Description</strong>
          </TableHeaderCell>
        </tr>
      </thead>
      <tbody className="BalanceTransactionTable">{rows}</tbody>
    </Table>
  );
};

const BalanceTransactionGroupSection = ({
  balanceTransactionGroup,
  balanceTransactionTypes,
}: BalanceTransactionGroupSectionProps) => {
  return (
    <>
      <Heading level={3} anchored id={balanceTransactionGroup.name}>
        {balanceTransactionGroup.title}
      </Heading>
      <p>{balanceTransactionGroup.description}</p>
      <BalanceTransactionGroupTable
        balanceTransactionTypes={balanceTransactionTypes}
      />
    </>
  );
};

export const BalanceTransactionTable = ({
  balanceTransactionGroups,
  balanceTransactionsMap,
}: BalanceTransactionTableProps) => {
  const sections = balanceTransactionGroups.map((group) => {
    return (
      <BalanceTransactionGroupSection
        key={group.name}
        balanceTransactionGroup={group}
        balanceTransactionTypes={balanceTransactionsMap[group.name]}
      />
    );
  });
  return <>{sections}</>;
};
